import api from "@/services/api";
import { DistributionConsumersResponseType } from "@/types/phase/Phases";

class GetDistributionConsumers {
  execute = async (date: string, missionId: number) => {
    const calendarDay = String(date).split("T")[0].slice(0, 10);
    const res = await api().get("/distributions/consumers", {
      params: { date: calendarDay, missionId },
    });
    return res.data as DistributionConsumersResponseType;
  };
}

export { GetDistributionConsumers };
